import { render } from "./UserSimpleView.vue?vue&type=template&id=f4071056&scoped=true&ts=true"
import script from "./UserSimpleView.vue?vue&type=script&lang=ts"
export * from "./UserSimpleView.vue?vue&type=script&lang=ts"

import "./UserSimpleView.vue?vue&type=style&index=0&id=f4071056&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4071056"]])

export default __exports__